import * as validators from '@vuelidate/validators';
import validator from 'validator';
import {
  checkPasswordIsDifferentFromEmail,
  checkLowerCaseCharacter,
  checkNumber,
  checkSpecialCharacter,
  checkUpperCaseCharacter,
  checkIllegalCharacters,
} from '../utils/password';

export default defineNuxtPlugin((nuxtApp) => {
  const { t } = nuxtApp.$i18n;

  // Create i18n message instance using nuxt i18n `t` function
  const withI18nMessage = validators.createI18nMessage({ t });

  // Define wrapped validators
  const customValidators = {
    required: withI18nMessage(validators.required),
    minLength: withI18nMessage(validators.minLength, { withArguments: true }),
    maxLength: withI18nMessage(validators.maxLength, { withArguments: true }),
    exactLength: withI18nMessage((param) => ({ $validator: (value) => value.length === param, $params: { param } }), {
      withArguments: true,
    }),
    email: withI18nMessage(validators.email, { withArguments: true }),
    emailExtended: withI18nMessage((value) =>
      /^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?: \(deleted on \d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\))?$/.test(value),
    ),
    minValue: withI18nMessage(validators.minValue, { withArguments: true }),
    maxValue: withI18nMessage(validators.maxValue, { withArguments: true }),
    enoughBalance: withI18nMessage(validators.maxValue, { withArguments: true }),
    numeric: withI18nMessage((value) => /^\d*(\.\d+)?$/.test(formatAmount(value))),
    notEqual: withI18nMessage((param) => (value) => value !== param, { withArguments: true }),
    sameAs: withI18nMessage(validators.sameAs, { withArguments: true }),
    requiredIf: withI18nMessage(validators.requiredIf, { withArguments: true }),
    nonEmptyArray: withI18nMessage((value) => value.length > 0),
    phone: withI18nMessage((value) => value == null || /^\+\d+(-\d+)?\s\d+$/.test(value)),
    name: withI18nMessage((value) =>
      /^[a-zA-Z\u00C0-\u017F\u0401\u0451\u0410-\u044F\u0621-\u064AА-ЩЬЮЯҐЄІЇа-щьюяґєії ёа-зй-шы-яЁА-ЗЙ-ШЫІіЎў]*$/.test(
        value,
      ),
    ),
    min1Number: withI18nMessage((value) => checkNumber(value)),
    min1LowerCase: withI18nMessage((value) => checkLowerCaseCharacter(value)),
    min1UpperCase: withI18nMessage((value) => checkUpperCaseCharacter(value)),
    min1SpecialCharacter: withI18nMessage((value) => checkSpecialCharacter(value)),
    illegalCharacters: withI18nMessage((value) => checkIllegalCharacters(value)),
    differentFromEmail: withI18nMessage(
      (param) => ({
        $validator: (value) => checkPasswordIsDifferentFromEmail(value, param),
        $params: { param },
      }),
      { withArguments: true },
    ),
    https: withI18nMessage((value) => /^https:\/\//.test(value)), // value.startsWith('https://')
    feeExceeds: withI18nMessage((param) => (value) => value > param, { withArguments: true }),
    ipOrHostname: withI18nMessage((value) => validator.isIP(value) || validator.isFQDN(value) || value === 'localhost'),
    isTrue: withI18nMessage((value) => value === true),
    alwaysValid: withI18nMessage(() => true),
  };

  // Provide validators globally
  nuxtApp.provide('validators', customValidators);
});
